import type { FC } from 'react';

import type { TIconProps } from './icon.props';

import { IconCheck } from './IconCheck';
import { IconChevronDown } from './IconChevronDown';
import { IconSearch } from './IconSearch';
import { IconLock } from './IconLock';
import { IconShield } from './IconShield';
import { IconChevronLeft } from './IconChevronLeft';
import { IconChevronRight } from './IconChevronRight';
import { IconAlertTriangle } from './IconAlertTriangle';
import { IconArrowUp } from './IconArrowUp';
import { IconInfo } from './IconInfo';
import { IconEye } from './IconEye';
import { IconEyeOff } from './IconEyeOff';
import { IconX } from './IconX';
import { IconTarget } from './IconTarget';
import { IconCard } from './IconCard';
import { IconDragHandle } from './IconDragHandle';
import { IconChevronUp } from './IconChevronUp';
import { IconSettings } from './IconSettings';
import { IconLogOut } from './IconLogOut';
import { IconPanelLeftClose } from './IconPanelLeftClose';
import { IconPerson } from './IconPerson';
import { IconSpinner } from './IconSpinner';

const ICONS = {
  'check': IconCheck,
  'chevron-down': IconChevronDown,
  'search': IconSearch,
  'lock': IconLock,
  'shield': IconShield,
  'chevron-left': IconChevronLeft,
  'chevron-right': IconChevronRight,
  'alert-triangle': IconAlertTriangle,
  'arrow-up': IconArrowUp,
  'info': IconInfo,
  'eye': IconEye,
  'eye-off': IconEyeOff,
  'x': IconX,
  'target': IconTarget,
  'card': IconCard,
  'drag-handle': IconDragHandle,
  'chevron-up': IconChevronUp,
  'settings': IconSettings,
  'log-out': IconLogOut,
  'panel-left-close': IconPanelLeftClose,
  'person': IconPerson,
  'spinner': IconSpinner,
} satisfies Record<string, FC<TIconProps>>;

type TIconName = keyof typeof ICONS;

export type {
  TIconName,
};
export {
  ICONS,
};
